
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28754",
  depVersions: {
  "payments-ui-app": "static-1.28754",
  "bend-plugin-arboretum": "static-1.2045",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.512",
  "crm_data": "static-4.93251",
  "data-fetching-client": "static-1.10136",
  "emoji-mart": "static-3.9",
  "enviro": "static-4.523",
  "foundations-components": "static-1.8782",
  "foundations-components-legacy": "static-1.1807",
  "head-dlb": "static-1.5330",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6089",
  "hs-test-utils": "static-1.8536",
  "hub-http": "static-1.6703",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11984",
  "I18n": "static-7.1714",
  "jasmine-runner": "static-1.6950",
  "quartz": "static-1.7692",
  "raven": "static-3.6411",
  "react-dlb": "static-1.96",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.123",
  "react-utils": "static-2.5676",
  "reselect": "static-3.18",
  "stripe-js": "static-1.122",
  "ui-components-test-utils": "static-1.6121",
  "UIComponents": "static-3.8930",
  "usage-tracker-public": "static-1.7631",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38094",
  "payments-checkout-lib": "static-1.677",
  "cssUtils": "static-1.1120",
  "customer-data-objects": "static-1.8207",
  "FireAlarmUi": "static-1.4887",
  "foundations-assets": "static-1.5386",
  "foundations-theming": "static-1.4987",
  "graphql": "static-1.95",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12291",
  "icons": "static-2.708",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3380",
  "property-translator": "static-1.5878",
  "quartz-config": "static-1.1470",
  "quartz-core": "static-1.6911",
  "quartz-i18n": "static-1.1367",
  "quartz-routing": "static-1.1122",
  "quartz-tracking": "static-1.1071",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17237",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "redux-toolkit": "static-1.84",
  "ReduxMessenger": "static-2.10868",
  "rpc-client-utils": "static-1.5164",
  "sanitize-text": "static-1.8655",
  "SharedI18nStrings": "static-1.190",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5255",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11643",
  "ui-images": "static-2.1282",
  "usage-tracker-core": "static-1.7670",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3969",
  "quartz-webpack": "static-1.3916",
  "bend-plugin-quartz-routing": "static-1.770",
  "bender-build-tools": "static-1.3613",
  "crm_universal": "static-1.22758",
  "customer-data-email": "static-1.18675",
  "customer-data-ui-utilities": "static-1.10329",
  "dispatcher": "static-1.150",
  "frontend-preferences-client": "static-1.8419",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8260",
  "quick-fetch": "static-1.4242",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5051",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2703",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9926",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.110",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3144",
  "ui-fonts": "static-1.1246",
  "HeadJS": "static-2.828",
  "hs-test-utils-bend-plugin": "static-1.3647",
  "msw": "static-1.105",
  "msw-config": "static-1.34",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.413",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4803",
  "foundations-components-test-utils": "static-1.6265",
  "ui-addon-draggable": "static-3.5248",
  "commerce-billing-lib": "static-1.20533",
  "commerce-shared-components-lib": "static-1.19615",
  "commerce-tools-ui-lib": "static-1.11359",
  "crm-message-bus": "static-1.44151",
  "customer-data-objects-ui-components": "static-1.13533",
  "customer-data-properties": "static-1.53122",
  "growth-payments-core": "static-1.26542",
  "ui-addon-iframeable": "static-1.9577",
  "usage-tracker": "static-1.7820",
  "usage-tracker-container": "static-1.7810",
  "sassPrefix": "static-1.385",
  "inbound-db-properties-service-client": "static-1.4162",
  "foundations-theming-base": "static-1.3972",
  "bend-plugin-foundations-theming": "static-1.3470",
  "stylex": "static-1.48",
  "opentelemetry-fe-types": "static-1.289",
  "hub-http-janus": "static-1.912",
  "hubspotter-http": "static-1.4986",
  "mobile-manifest-mixins": "static-1.611",
  "module-federation": "static-1.41",
  "opentelemetry-fe": "static-1.664",
  "quartz-auth": "static-1.1367",
  "quartz-head": "static-1.1357",
  "quartz-test": "static-1.1367",
  "trellis-components": "static-1.3163",
  "usage-tracker-session-replay": "static-1.5506",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.197",
  "web-vitals": "static-1.21",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.574",
  "chirp-fetch": "static-1.2402",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4970",
  "FormUrlGenerator": "static-2.5212",
  "sequences-lib": "static-1.8821",
  "apollo-link-hub-http": "static-2.5086",
  "FileManagerCore": "static-1.40375",
  "FileManagerLib": "static-1.40516",
  "hubspot-apollo-client": "static-1.5380",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.755",
  "timezone-utils": "static-2.5728",
  "ui-gdpr-components": "static-1.10658",
  "react-dnd-compat": "static-1.5108",
  "stylex-utils": "static-1.181",
  "trellis-theming": "static-1.1514",
  "react-flip-move": "static-1.85",
  "avatar-components": "static-1.2986",
  "hs-resources": "static-1.682",
  "pulse": "static-1.1147",
  "utility-belt": "static-1.3035",
  "zustand": "static-1.91",
  "batch-promise": "static-1.2047",
  "customer-data-associations": "static-1.7836",
  "customer-data-property-utils": "static-1.8550",
  "customer-data-tracking": "static-1.7370",
  "framework-data-schema-resolvers": "static-1.7391",
  "framework-data-table": "static-2.12876",
  "object-builder-ui-client": "static-1.50100",
  "payments-enrollment-embed-lib": "static-1.24269",
  "stripe-embedded-components": "static-1.8281",
  "ui-addon-opt": "static-4.8914",
  "ai-components-ui-library": "static-1.10062",
  "customer-data-rte": "static-1.33938",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24876",
  "growth-onboarding-confetti": "static-1.3556",
  "growth-onboarding-empty-states": "static-1.6569",
  "hubspot-prosemirror": "static-1.19319",
  "InboxConnectUtils": "static-4.15880",
  "payment-link-components": "static-1.24501",
  "payments-post-enroll-local-storage-lib": "static-1.5604",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39211",
  "react-colorpicker": "static-2.10707",
  "ui-addon-upgrades": "static-9.18560",
  "ui-addon-video-player": "static-1.9121",
  "user-context": "static-1.5552",
  "restore-request-side-panel-lib": "static-1.2073",
  "atom": "static-1.5569",
  "reference-resolvers": "static-1.8682",
  "calling-global-api": "static-1.66263",
  "calling-internal-common": "static-1.31820",
  "calling-lifecycle-internal": "static-1.67645",
  "calling-lifecycle-messages": "static-1.59937",
  "commerce-products-lib": "static-1.10967",
  "conditional-properties-service-client": "static-1.4125",
  "crm-index-visualization-core": "static-1.4787",
  "crm-links": "static-1.6811",
  "crm-pipelines-api-client-types": "static-1.4455",
  "customer-data-properties-shared-msw-handlers": "static-1.10266",
  "data-agent-utils": "static-1.969",
  "data-token-picker": "static-1.17169",
  "external-options-client-types": "static-1.4450",
  "formula-editor": "static-1.15039",
  "google-libphonenumber": "static-1.52",
  "inbound-db-meta-service-client": "static-1.3786",
  "inbounddb-objects-service-types": "static-1.4526",
  "meetings-icalendar-utils-lib": "static-1.1129",
  "multi-currency-client-types": "static-1.4020",
  "pipeline-validation-client-types": "static-1.4295",
  "property-value-citations": "static-1.3736",
  "react-tinymce": "static-1.56308",
  "reference-resolvers-lite": "static-1.8611",
  "rich-text-lib": "static-1.20589",
  "smart-data-capture-core": "static-1.528",
  "tiered-pricing": "static-1.2320",
  "tinymce-config": "static-2.55434",
  "tinymce-plugins": "static-1.58548",
  "tinymce-themes": "static-1.57404",
  "topics-actions-lib": "static-1.682",
  "trellis-ext-i18n": "static-1.1421",
  "trial-components-library": "static-1.14421",
  "ui-addon-emoji-picker": "static-1.10362",
  "ui-addon-form-validation": "static-1.11352",
  "laboratory-lib": "static-3.7644",
  "onboarding-scopes": "static-1.6951",
  "seat-types-lib": "static-1.1084",
  "magpie-lib": "static-1.5927",
  "navigation-messaging": "static-1.8540",
  "ts-schema": "static-1.4406",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10939",
  "hubspotter-http-shared-msw-handlers": "static-1.10937",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8678",
  "audio-components": "static-1.6603",
  "breeze-artifacts-sdk": "static-1.1059",
  "ContentUtils": "static-1.69527",
  "copilot-toolkit": "static-1.12191",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30093",
  "FileManagerImages": "static-1.38027",
  "html-to-image": "static-1.67",
  "immerable": "static-1.4640",
  "ui-universal-auth": "static-1.9783",
  "urlinator": "static-1.5011",
  "video-components": "static-1.14487",
  "video-data-lib": "static-1.36143",
  "video-embed": "static-1.36977",
  "hubspot-apollo-cache": "static-1.839",
  "trellis-migration-context": "static-1.76",
  "event-emitter": "static-1.1459",
  "fdsr-migration-layer": "static-1.510",
  "framework-builder-read-service-client": "static-1.4347",
  "bend-plugin-pulse": "static-1.650",
  "fast-json-patch": "static-1.76",
  "framework-data-schema-quick-fetch": "static-1.7296",
  "persist-promise": "static-1.4204",
  "customer-data-reference-ui-components": "static-1.13672",
  "reporting-data": "static-1.69430",
  "tasks-actions-lib": "static-1.474",
  "purchase-motions-components": "static-1.6662",
  "growth-onboarding-feedback-components": "static-1.7079",
  "growth-onboarding-reliability": "static-1.5581",
  "marketplace-ui-apps-core": "static-1.19594",
  "onboarding-tours": "static-1.17421",
  "stripe-connect-js": "static-1.85",
  "chatspot-core": "static-1.24004",
  "content-assistance-lib": "static-1.8452",
  "draft-content-plugins": "static-1.29192",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22392",
  "breeze-engine-lib": "static-1.2253",
  "poll-commands": "static-1.3975",
  "video-components-external": "static-1.12485",
  "trellis-story-utils": "static-1.4997",
  "ui-addon-react-router-dom": "static-1.10023",
  "content-media-capture": "static-1.5829",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9595",
  "ui-shepherd-react": "static-3.10778",
  "hub-http-contrib": "static-1.3530",
  "ui-addon-sales-email": "static-1.5700",
  "commerce-tours-lib": "static-1.6894",
  "getting-started-shared-tasks": "static-1.19602",
  "sales-checkout-service-client": "static-1.4019",
  "merchandise-lib": "static-1.288",
  "getting-started-shared-tasks-store": "static-1.18720",
  "onboarding-tours-utils": "static-1.1488",
  "calling-error-reporting": "static-1.31827",
  "shared-worker-versioning": "static-1.11541",
  "calling-usage-tracker": "static-1.7038",
  "conversations-skeleton-state": "static-1.7616",
  "voice-sms-access-library": "static-1.2518",
  "commerce-permissions": "static-1.1285",
  "products-iframe-lib": "static-1.8956",
  "products-ui-components-shared-msw-handlers": "static-1.11321",
  "crm-index-associations-lib": "static-1.6946",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11022",
  "sales-views-client-types": "static-1.4756",
  "location-customization-utils-lib": "static-1.10462",
  "data-agent-kit": "static-1.956",
  "enrichment-settings-lib": "static-1.281",
  "fsm": "static-1.4255",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7302",
  "bark-lib": "static-1.17032",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6395",
  "react-codemirror": "static-1.11140",
  "tinymce": "static-5.11",
  "interframe": "static-3.5240",
  "tinymce-data": "static-1.41519",
  "layout-dnd-components": "static-1.13261",
  "layout-dnd-utils": "static-1.12236",
  "ui-brand-identity-lib": "static-1.17000",
  "NamespacedHubStyle": "static-2.9379",
  "embedded-academy-lib": "static-1.16069",
  "hubs-service-types": "static-1.1765",
  "navigation-components": "static-1.19213",
  "nest": "static-1.734",
  "nudge-client-utils": "static-1.3452",
  "purchase-motions-api": "static-1.6665",
  "signup-constants": "static-1.19982",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5387",
  "reactive-lib": "static-1.1218",
  "simple-logging-lib": "static-1.3549",
  "nav-meta": "static-1.30850",
  "breeze-engine-core": "static-1.1531",
  "cms-field-types": "static-1.5308",
  "content-icons-ui": "static-1.2479",
  "integrations-lib": "static-1.17476",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.347",
  "unified-auth-core-lib": "static-1.1579",
  "social-insights-client-types": "static-1.22967",
  "outpost": "static-1.4628",
  "reporting-client-types": "static-1.2857",
  "signup-ui-url-generator": "static-2.8535",
  "developer-experience-shared-components": "static-1.11040",
  "immutable-less": "static-1.5149",
  "marketplace-ui-client-types": "static-1.18469",
  "marketplace-ui-common": "static-1.21062",
  "ui-addon-integrations-directory-panel": "static-2.8451",
  "ui-extensibility-client-types": "static-1.4412",
  "growth-data-modal": "static-1.6166",
  "growth-onboarding-next-action-utils": "static-1.3023",
  "onboarding-tours-client": "static-1.5636",
  "ui-shepherd-tracker": "static-1.8159",
  "ui-coaching-tips": "static-1.29606",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1231",
  "highlight.js": "static-1.92",
  "content-media-composition-data-lib": "static-1.13633",
  "content-media-compositions": "static-2.17640",
  "media-bridge-lib": "static-1.19674",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4927",
  "calling-orchestration-schema": "static-1.37295",
  "crm-record-cards-service-types": "static-1.3873",
  "highcharts": "static-8.117",
  "storybook-react": "static-1.46",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16706",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69602",
  "layout-data-lib": "static-1.10561",
  "academy-common-lib": "static-1.15530",
  "nudge-custom-function-registry": "static-1.3209",
  "nudge-renderer-utils": "static-1.3528",
  "whisper-core-api": "static-1.7673",
  "flux-actions": "static-1.383",
  "integrations-error-boundary-lib": "static-1.14891",
  "integrations-tracking-lib": "static-1.6121",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4107",
  "oauth-service-types": "static-1.4634",
  "ai-settings-ui-library": "static-1.8626",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1646",
  "onboarding-data-sync-lib": "static-1.2869",
  "growth-onboarding-next-action-components": "static-1.3051",
  "user-context-client": "static-1.5007",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15851",
  "advanced-menus-lib": "static-1.12595",
  "ExportDialog": "static-6.10871",
  "ui-memberships-settings-lib": "static-1.35239",
  "academy-service-client": "static-1.4189",
  "croppie": "static-2.10",
  "final-form": "static-1.85",
  "SafeStorage": "static-1.4893",
  "trellis-ecosystem": "static-1.7883",
  "wootric-nps": "static-1.7309",
  "universal-page-editor-lib": "static-1.3511",
  "settings-ui-lib": "static-1.13026",
  "simple-data-table": "static-1.3857",
  "meetings-connect-utils-lib": "static-1.8118",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15850",
  "simple-menus-lib": "static-1.17367",
  "crm-record-cards-client": "static-1.100"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28754",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2045",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.512",
  "crm_data": "/crm_data/static-4.93251",
  "data-fetching-client": "/data-fetching-client/static-1.10136",
  "emoji-mart": "/emoji-mart/static-3.9",
  "enviro": "/enviro/static-4.523",
  "foundations-components": "/foundations-components/static-1.8782",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1807",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6089",
  "hs-test-utils": "/hs-test-utils/static-1.8536",
  "hub-http": "/hub-http/static-1.6703",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11984",
  "I18n": "/I18n/static-7.1714",
  "jasmine-runner": "/jasmine-runner/static-1.6950",
  "quartz": "/quartz/static-1.7692",
  "raven": "/raven/static-3.6411",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.123",
  "react-utils": "/react-utils/static-2.5676",
  "reselect": "/reselect/static-3.18",
  "stripe-js": "/stripe-js/static-1.122",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6121",
  "UIComponents": "/UIComponents/static-3.8930",
  "usage-tracker-public": "/usage-tracker-public/static-1.7631",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38094",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.677",
  "cssUtils": "/cssUtils/static-1.1120",
  "customer-data-objects": "/customer-data-objects/static-1.8207",
  "FireAlarmUi": "/FireAlarmUi/static-1.4887",
  "foundations-assets": "/foundations-assets/static-1.5386",
  "foundations-theming": "/foundations-theming/static-1.4987",
  "graphql": "/graphql/static-1.95",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12291",
  "icons": "/icons/static-2.708",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3380",
  "property-translator": "/property-translator/static-1.5878",
  "quartz-config": "/quartz-config/static-1.1470",
  "quartz-core": "/quartz-core/static-1.6911",
  "quartz-i18n": "/quartz-i18n/static-1.1367",
  "quartz-routing": "/quartz-routing/static-1.1122",
  "quartz-tracking": "/quartz-tracking/static-1.1071",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17237",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "ReduxMessenger": "/ReduxMessenger/static-2.10868",
  "rpc-client-utils": "/rpc-client-utils/static-1.5164",
  "sanitize-text": "/sanitize-text/static-1.8655",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5255",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11643",
  "ui-images": "/ui-images/static-2.1282",
  "usage-tracker-core": "/usage-tracker-core/static-1.7670",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3969",
  "quartz-webpack": "/quartz-webpack/static-1.3916",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.770",
  "bender-build-tools": "/bender-build-tools/static-1.3613",
  "crm_universal": "/crm_universal/static-1.22758",
  "customer-data-email": "/customer-data-email/static-1.18675",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10329",
  "dispatcher": "/dispatcher/static-1.150",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8419",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8260",
  "quick-fetch": "/quick-fetch/static-1.4242",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5051",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2703",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9926",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.110",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3144",
  "ui-fonts": "/ui-fonts/static-1.1246",
  "HeadJS": "/HeadJS/static-2.828",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3647",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.34",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.413",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4803",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6265",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5248",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20533",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19615",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11359",
  "crm-message-bus": "/crm-message-bus/static-1.44151",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13533",
  "customer-data-properties": "/customer-data-properties/static-1.53122",
  "growth-payments-core": "/growth-payments-core/static-1.26542",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9577",
  "usage-tracker": "/usage-tracker/static-1.7820",
  "usage-tracker-container": "/usage-tracker-container/static-1.7810",
  "sassPrefix": "/sassPrefix/static-1.385",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4162",
  "foundations-theming-base": "/foundations-theming-base/static-1.3972",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3470",
  "stylex": "/stylex/static-1.48",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.289",
  "hub-http-janus": "/hub-http-janus/static-1.912",
  "hubspotter-http": "/hubspotter-http/static-1.4986",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.611",
  "module-federation": "/module-federation/static-1.41",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.664",
  "quartz-auth": "/quartz-auth/static-1.1367",
  "quartz-head": "/quartz-head/static-1.1357",
  "quartz-test": "/quartz-test/static-1.1367",
  "trellis-components": "/trellis-components/static-1.3163",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5506",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.197",
  "web-vitals": "/web-vitals/static-1.21",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.574",
  "chirp-fetch": "/chirp-fetch/static-1.2402",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4970",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5212",
  "sequences-lib": "/sequences-lib/static-1.8821",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5086",
  "FileManagerCore": "/FileManagerCore/static-1.40375",
  "FileManagerLib": "/FileManagerLib/static-1.40516",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5380",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.755",
  "timezone-utils": "/timezone-utils/static-2.5728",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "react-dnd-compat": "/react-dnd-compat/static-1.5108",
  "stylex-utils": "/stylex-utils/static-1.181",
  "trellis-theming": "/trellis-theming/static-1.1514",
  "react-flip-move": "/react-flip-move/static-1.85",
  "avatar-components": "/avatar-components/static-1.2986",
  "hs-resources": "/hs-resources/static-1.682",
  "pulse": "/pulse/static-1.1147",
  "utility-belt": "/utility-belt/static-1.3035",
  "zustand": "/zustand/static-1.91",
  "batch-promise": "/batch-promise/static-1.2047",
  "customer-data-associations": "/customer-data-associations/static-1.7836",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8550",
  "customer-data-tracking": "/customer-data-tracking/static-1.7370",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7391",
  "framework-data-table": "/framework-data-table/static-2.12876",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50100",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24269",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8281",
  "ui-addon-opt": "/ui-addon-opt/static-4.8914",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10062",
  "customer-data-rte": "/customer-data-rte/static-1.33938",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24876",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3556",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6569",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19319",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15880",
  "payment-link-components": "/payment-link-components/static-1.24501",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5604",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39211",
  "react-colorpicker": "/react-colorpicker/static-2.10707",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18560",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9121",
  "user-context": "/user-context/static-1.5552",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2073",
  "atom": "/atom/static-1.5569",
  "reference-resolvers": "/reference-resolvers/static-1.8682",
  "calling-global-api": "/calling-global-api/static-1.66263",
  "calling-internal-common": "/calling-internal-common/static-1.31820",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67645",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59937",
  "commerce-products-lib": "/commerce-products-lib/static-1.10967",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4125",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4787",
  "crm-links": "/crm-links/static-1.6811",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4455",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10266",
  "data-agent-utils": "/data-agent-utils/static-1.969",
  "data-token-picker": "/data-token-picker/static-1.17169",
  "external-options-client-types": "/external-options-client-types/static-1.4450",
  "formula-editor": "/formula-editor/static-1.15039",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3786",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4526",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1129",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4020",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4295",
  "property-value-citations": "/property-value-citations/static-1.3736",
  "react-tinymce": "/react-tinymce/static-1.56308",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8611",
  "rich-text-lib": "/rich-text-lib/static-1.20589",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.528",
  "tiered-pricing": "/tiered-pricing/static-1.2320",
  "tinymce-config": "/tinymce-config/static-2.55434",
  "tinymce-plugins": "/tinymce-plugins/static-1.58548",
  "tinymce-themes": "/tinymce-themes/static-1.57404",
  "topics-actions-lib": "/topics-actions-lib/static-1.682",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1421",
  "trial-components-library": "/trial-components-library/static-1.14421",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10362",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "laboratory-lib": "/laboratory-lib/static-3.7644",
  "onboarding-scopes": "/onboarding-scopes/static-1.6951",
  "seat-types-lib": "/seat-types-lib/static-1.1084",
  "magpie-lib": "/magpie-lib/static-1.5927",
  "navigation-messaging": "/navigation-messaging/static-1.8540",
  "ts-schema": "/ts-schema/static-1.4406",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10939",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10937",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8678",
  "audio-components": "/audio-components/static-1.6603",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1059",
  "ContentUtils": "/ContentUtils/static-1.69527",
  "copilot-toolkit": "/copilot-toolkit/static-1.12191",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30093",
  "FileManagerImages": "/FileManagerImages/static-1.38027",
  "html-to-image": "/html-to-image/static-1.67",
  "immerable": "/immerable/static-1.4640",
  "ui-universal-auth": "/ui-universal-auth/static-1.9783",
  "urlinator": "/urlinator/static-1.5011",
  "video-components": "/video-components/static-1.14487",
  "video-data-lib": "/video-data-lib/static-1.36143",
  "video-embed": "/video-embed/static-1.36977",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.839",
  "trellis-migration-context": "/trellis-migration-context/static-1.76",
  "event-emitter": "/event-emitter/static-1.1459",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.510",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4347",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.650",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7296",
  "persist-promise": "/persist-promise/static-1.4204",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13672",
  "reporting-data": "/reporting-data/static-1.69430",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.474",
  "purchase-motions-components": "/purchase-motions-components/static-1.6662",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7079",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5581",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19594",
  "onboarding-tours": "/onboarding-tours/static-1.17421",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "chatspot-core": "/chatspot-core/static-1.24004",
  "content-assistance-lib": "/content-assistance-lib/static-1.8452",
  "draft-content-plugins": "/draft-content-plugins/static-1.29192",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22392",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2253",
  "poll-commands": "/poll-commands/static-1.3975",
  "video-components-external": "/video-components-external/static-1.12485",
  "trellis-story-utils": "/trellis-story-utils/static-1.4997",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10023",
  "content-media-capture": "/content-media-capture/static-1.5829",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9595",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10778",
  "hub-http-contrib": "/hub-http-contrib/static-1.3530",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5700",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6894",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19602",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4019",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18720",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1488",
  "calling-error-reporting": "/calling-error-reporting/static-1.31827",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11541",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7038",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7616",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2518",
  "commerce-permissions": "/commerce-permissions/static-1.1285",
  "products-iframe-lib": "/products-iframe-lib/static-1.8956",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11321",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6946",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11022",
  "sales-views-client-types": "/sales-views-client-types/static-1.4756",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10462",
  "data-agent-kit": "/data-agent-kit/static-1.956",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.281",
  "fsm": "/fsm/static-1.4255",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7302",
  "bark-lib": "/bark-lib/static-1.17032",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6395",
  "react-codemirror": "/react-codemirror/static-1.11140",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5240",
  "tinymce-data": "/tinymce-data/static-1.41519",
  "layout-dnd-components": "/layout-dnd-components/static-1.13261",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12236",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17000",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9379",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16069",
  "hubs-service-types": "/hubs-service-types/static-1.1765",
  "navigation-components": "/navigation-components/static-1.19213",
  "nest": "/nest/static-1.734",
  "nudge-client-utils": "/nudge-client-utils/static-1.3452",
  "purchase-motions-api": "/purchase-motions-api/static-1.6665",
  "signup-constants": "/signup-constants/static-1.19982",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5387",
  "reactive-lib": "/reactive-lib/static-1.1218",
  "simple-logging-lib": "/simple-logging-lib/static-1.3549",
  "nav-meta": "/nav-meta/static-1.30850",
  "breeze-engine-core": "/breeze-engine-core/static-1.1531",
  "cms-field-types": "/cms-field-types/static-1.5308",
  "content-icons-ui": "/content-icons-ui/static-1.2479",
  "integrations-lib": "/integrations-lib/static-1.17476",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.347",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1579",
  "social-insights-client-types": "/social-insights-client-types/static-1.22967",
  "outpost": "/outpost/static-1.4628",
  "reporting-client-types": "/reporting-client-types/static-1.2857",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8535",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11040",
  "immutable-less": "/immutable-less/static-1.5149",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18469",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21062",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8451",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4412",
  "growth-data-modal": "/growth-data-modal/static-1.6166",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3023",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5636",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8159",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29606",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1231",
  "highlight.js": "/highlight.js/static-1.92",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13633",
  "content-media-compositions": "/content-media-compositions/static-2.17640",
  "media-bridge-lib": "/media-bridge-lib/static-1.19674",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4927",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37295",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3873",
  "highcharts": "/highcharts/static-8.117",
  "storybook-react": "/storybook-react/static-1.46",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16706",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69602",
  "layout-data-lib": "/layout-data-lib/static-1.10561",
  "academy-common-lib": "/academy-common-lib/static-1.15530",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3209",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3528",
  "whisper-core-api": "/whisper-core-api/static-1.7673",
  "flux-actions": "/flux-actions/static-1.383",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14891",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6121",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4107",
  "oauth-service-types": "/oauth-service-types/static-1.4634",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8626",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1646",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2869",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3051",
  "user-context-client": "/user-context-client/static-1.5007",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15851",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12595",
  "ExportDialog": "/ExportDialog/static-6.10871",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35239",
  "academy-service-client": "/academy-service-client/static-1.4189",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.85",
  "SafeStorage": "/SafeStorage/static-1.4893",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7883",
  "wootric-nps": "/wootric-nps/static-1.7309",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3511",
  "settings-ui-lib": "/settings-ui-lib/static-1.13026",
  "simple-data-table": "/simple-data-table/static-1.3857",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8118",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15850",
  "simple-menus-lib": "/simple-menus-lib/static-1.17367",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.100"
}
};
